import { Icon } from "../../../../core/icon";
import { BRUSH_SIZE_SLIDER_ID } from "../ui-panes/BrushSizePane";
import { PALETTE_PANE_ID } from "../ui-panes/PalettePane";
import { brushLikeOnClick, brushLikeOnDrag, brushLikeOnDragEnd, brushlikeOnHover } from "./_common";
export const BrushToolID = 'brush';
const changeLabel = 'Paint Hexes';
export const createBrushTool = (props) => {
    const [_, addToHexModel] = props.hexMapModelContext;
    return {
        id: BrushToolID,
        label: 'Brush',
        icon: Icon.TOOL_BRUSH,
        disablePan: true,
        usesToolOptions: {
            [PALETTE_PANE_ID]: true,
            [BRUSH_SIZE_SLIDER_ID]: true,
        },
        onClick: brushLikeOnClick(props, (hexes) => addToHexModel(changeLabel, hexes)),
        onDrag: brushLikeOnDrag(props),
        onDragEnd: brushLikeOnDragEnd(props, (hexes) => addToHexModel(changeLabel, hexes)),
        onHover: brushlikeOnHover(props),
    };
};
createBrushTool.toolID = BrushToolID;
//# sourceMappingURL=brushTool.js.map